import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import JobSearchForm from "../components/JobSearchForm";
import { formatAUDate, formatAUTime } from "../global-client";

//import { useState } from "react";
import { searchJobs } from "../redux/actions/jobActions";
import { resetSearchResults } from "../redux/slices/job";
import SearchResultRow from "./screenComponents/SearchResultRow";

const JobSearchScreen = () => {
  const dispatch = useDispatch();
  const { searchResults } = useSelector((state) => state.job);
  //const [searchSelectedRow, setSearchSelectedRow] = useState(-1);
  // const [value, setValue] = useState("");
  // const [searchBy, setSearchBy] = useState("serial");
  // const [dateFrom, setDateFrom] = useState(null);
  // const [dateTo, setDateTo] = useState(null);

  return (
    <Box p={4}>
      <JobSearchForm
        onSearch={(searchBy, searchValue, dateFrom, dateTo) => {
          // Implement the search logic here or dispatch an action
          //console.log("Search by:", searchBy, "Value:", searchValue, "From:", dateFrom, "To:", dateTo);

          dispatch(searchJobs(searchBy, searchValue, dateFrom, dateTo)); // Example action dispatch
        }}
        // onValueChange={(newValue) => {
        //   setValue(newValue);
        // }}
        // onSearchByChange={(newSearchBy) => {
        //   setSearchBy(newSearchBy);
        // }}
        onFromDateChange={(newDateFrom) => {
          //setDateFrom(newDateFrom);
        }}
        onToDateChange={(newDateTo) => {
          //setDateTo(newDateTo);
        }}
      />
      <Box mt={8} textAlign='center' mx={{ base: 0, md: 8 }}>
        {/* Render search results here using data from Redux store */}
        {(!searchResults || searchResults.length === 0) && (
          <Text fontSize='sm' fontWeight='light' mb={4}>
            No Jobs Found for Given Search Criteria
          </Text>
        )}
        {/* Example: Map through search results and display them */}
        <Flex justify='center' mt={2}>
          {searchResults && searchResults.length > 0 && (
            <Button
              my={2}
              colorScheme='red'
              justifySelf='center'
              onClick={() => {
                dispatch(resetSearchResults());
                //setSearchSelectedRow(-1);
                //setValue("");
              }}
            >
              Clear Search Results <Text ml='2'>({searchResults.length})</Text>
            </Button>
          )}
        </Flex>
        {searchResults && searchResults.length > 0 && (
          <Box overflowX='auto' w='100%'>
            <Flex
              direction='column'
              p='4'
              mb='2'
              fontFamily='sans-serif'
              fontSize={{ base: "xs", md: "sm" }}
              minW='max-content'
            >
              <SearchResultRow
                key={-1}
                index={-1}
                number='JobNo'
                date='Date'
                time='Time'
                customer='Customer Name'
                console='Console'
                serial='Serial'
                jobName='Job Name'
                booking='B'
                complete='C'
                pickedUp='P'
                irreparable='I'
                header
                fontSize='sm'
                isBooking={false}
                isCancelled={false}
              />
              {searchResults.map((job, index) => (
                <SearchResultRow
                  key={job.JOB_ID}
                  jobId={job.JOB_ID}
                  index={index}
                  number={job.JOB_NO}
                  date={formatAUDate(job.JOB_DATE, { weekday: false })}
                  time={formatAUTime(job.JOB_DATE)}
                  customer={job.CUST_FNAME + " " + job.CUST_SNAME}
                  console={job.CONSOLE_NAME}
                  serial={job.CONSOLE_SERIAL}
                  jobName={job.JOB_NAME2}
                  complete={job.COMPLETE}
                  pickedUp={job.PICKEDUP}
                  irreparable={job.IRREPARABLE}
                  isBooking={job.BOOKING === 1}
                  isCancelled={job.CANCELLED === 1}
                  // onSelect={(row) => {
                  //   setSearchSelectedRow(row);
                  // }}
                  //selected={searchSelectedRow === index}
                />
              ))}
            </Flex>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default JobSearchScreen;
